// extracted by mini-css-extract-plugin
export default {"root":"form-row_root_M1dZ7","submit":"form-row_submit_AmTOj"};